import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/vendor/$buyerSlug/")({
	beforeLoad: ({ params }) => {
		throw redirect({
			to: "/vendor/$buyerSlug/solicitations",
			params: { buyerSlug: params.buyerSlug },
		});
	},
	component: () => null,
});
